import { usePageSEO } from "@/lib/use-page-seo";
import WCLogo from "@/components/WCLogo";
import FAQSection from "@/components/FAQSection";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "@/components/LanguageSwitcher";
import { useLocalePath } from "@/lib/use-locale-path";

export default function FAQPage() {
  usePageSEO("meta.faq_title", "/faq");
  const { t } = useTranslation();
  const lp = useLocalePath();
  return (
    <div className="min-h-screen bg-background text-foreground">
      <header className="border-b border-border/40 bg-background/80">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 flex items-center justify-between h-14">
          <WCLogo />
          <div className="flex items-center gap-4">
            <a href={lp("/")} className="text-sm text-muted-foreground hover:text-foreground transition-colors">
              {t("nav.back")}
            </a>
            <LanguageSwitcher />
          </div>
        </div>
      </header>
      <main className="max-w-4xl mx-auto px-4 sm:px-6 py-12">
        <FAQSection />

        {/* Privacy policy stub */}
        <section className="mt-16 pt-10 border-t border-border/30">
          <h2
            className="text-3xl font-bold uppercase mb-4"
            style={{ fontFamily: "'Barlow Condensed', sans-serif" }}
          >
            {t("privacy.heading")}
          </h2>
          <div className="text-sm text-muted-foreground space-y-4 max-w-2xl">
            <p>{t("privacy.p1")}</p>
            <p>{t("privacy.p2")}</p>
            <p>{t("privacy.p3")}</p>
            <p>{t("privacy.p4")}</p>
            <p>{t("privacy.p5")}</p>
          </div>
        </section>
      </main>
    </div>
  );
}
